module.exports = __webpack_public_path__ + "static/img/userPhoto.fb3aff37.png";